/** Sort helpers for Admin Task > Subscriptions.

The list is paged (50–500), so a header click re-sorts the current page
immediately and sends `sort_by`/`sort_dir` on the next list request so the
server window matches the column the operator clicked.

These keys are the live `subscription_get` allow-list (`id`, `name`,
`name_en`, `date_create`, `is_template`). Action / remarks / delete are not
sortable from the header.
*/

export const DEFAULT_SUBSCRIPTION_SORT_BY = 'date_create';
export const DEFAULT_SUBSCRIPTION_SORT_DIR = 'DESC';

export const SUBSCRIPTION_SORT_COLUMNS = [
  'id',
  'name',
  'name_en',
  'is_template',
  'date_create',
];

const DESC_FIRST_COLUMNS = new Set(['date_create', 'id']);

export function nextSubscriptionSort(sortBy, sortDir, column) {
  if (sortBy === column) {
    return {
      sortBy: column,
      sortDir: String(sortDir).toUpperCase() === 'ASC' ? 'DESC' : 'ASC',
    };
  }
  return {
    sortBy: column,
    sortDir: DESC_FIRST_COLUMNS.has(column) ? 'DESC' : 'ASC',
  };
}

function dateMillis(value) {
  if (!value) {
    return null;
  }
  const t = Date.parse(String(value).replace(' ', 'T'));
  return Number.isNaN(t) ? null : t;
}

function templateRank(row) {
  const value = row && row.is_template;
  return value === true || String(value) === '1' ? 1 : 0;
}

function sortValue(row, column) {
  switch (column) {
    case 'id': {
      const n = parseInt(row && row.id, 10);
      return Number.isFinite(n) ? n : null;
    }
    case 'name':
      return String((row && row.name) || '');
    case 'name_en':
      return String((row && row.name_en) || '');
    case 'is_template':
      return templateRank(row);
    case 'date_create':
      return dateMillis(row && row.date_create);
    default:
      return '';
  }
}

function compareValues(va, vb, dir) {
  if (va == null && vb == null) {
    return 0;
  }
  if (va == null) {
    return 1;
  }
  if (vb == null) {
    return -1;
  }
  if (typeof va === 'number' && typeof vb === 'number') {
    return (va - vb) * dir;
  }
  return String(va).localeCompare(String(vb), 'zh-Hant', {
    numeric: true,
    sensitivity: 'base',
  }) * dir;
}

export function sortSubscriptionRows(rows, sortBy, sortDir) {
  const list = Array.isArray(rows) ? rows : [];
  const dir = String(sortDir).toUpperCase() === 'ASC' ? 1 : -1;
  const column = SUBSCRIPTION_SORT_COLUMNS.includes(sortBy)
    ? sortBy
    : DEFAULT_SUBSCRIPTION_SORT_BY;
  return [...list].sort((a, b) => compareValues(sortValue(a, column), sortValue(b, column), dir));
}
